import * as $ from "jquery";
import { MediaMatcher } from "@angular/cdk/layout";
import { NavigationEnd, Router } from "@angular/router";
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  OnInit,
} from "@angular/core";

import { AppHeaderComponent } from "./header/header.component";
import { AppSidebarComponent } from "./sidebar/sidebar.component";
import { MenuItems } from "../../shared/menu-items/menu-items";
import { CommonService } from "../../shared/common.service";
import { MatSidenav } from "@angular/material";
import { SidenavService } from "../../shared/sidebar.service";
import { MobileDetectionService } from "../../shared/services/mobile-detection.service";
import { ResetEventService } from "../../shared/services/reset-event.service";
import { filter } from "rxjs/operators";
import { TriggerEvents } from "../../shared/services/trigger-event.service";
import { Subscription } from "rxjs";
import { MainService } from "../../main/main.service";

/** @title Responsive sidenav */
@Component({
  selector: "app-full-layout",
  templateUrl: "full.component.html",
  styleUrls: ["full.component.scss"],
})
export class FullComponent implements OnDestroy, AfterViewInit, OnInit {
  mobileQuery: MediaQueryList;
  userData;
  contentLoaded = false;
  public isMobile: boolean;
  showToggle = true;
  private subscription: Subscription;
  private _mobileQueryListener: () => void;
  @ViewChild("snav", { static: true }) public sidenav: MatSidenav;
  public currentRoute: string = "";
  inCreateBooking: boolean = false;
  backIcon: boolean = false;
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private commonservice: CommonService,
    public sidenavService: SidenavService,
    private router: Router,
    private mobileService: MobileDetectionService,
    private resetEventService: ResetEventService,
    private triggerEvents: TriggerEvents,
    private dataService: MainService
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 768px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.contentLoaded = false;
        setTimeout(() => (this.contentLoaded = true), 100);
      }
    });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        console.log(event.url, "event url");
        if (event.url === "/main/create-booking/add") {
          this.inCreateBooking = true;
          this.backIcon = false;

          console.log("Now on create booking route");
          // Add your logic here
        }
        if (event.url === "/main/create-booking/view") {
          this.inCreateBooking = false;
          this.backIcon = false;

          console.log("Now on create booking route");
          // Add your logic here
        }
      });
  }

  ngOnInit() {
    this.subscription = this.triggerEvents.headerToggle$.subscribe(
      (value: boolean) => {
        console.log("value triggered", value);

        this.showToggle = value;
      }
    );
    this.mobileService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
    this.userData = this.commonservice.getUser();

    this.currentRoute = this.router.url; // initial value

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
        console.log("Current route:", this.currentRoute);
      }
    });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        console.log(event.url, "event url");
        if (event.url === "/main/booking-management/create-booking") {
          //  this.serviceHeading = "";

          this.inCreateBooking = true;
          this.backIcon = false;

          console.log("Now on create booking route");
          // Add your logic here
        }
        if (event.url === "/main/create-booking/view") {
          // this.serviceHeading = "Bookings";
          this.inCreateBooking = false;
        }
      });
    this.subscription = this.dataService.sharedData6$.subscribe((data) => {
      console.log(data, "data");
      if (data) {
        this.backIcon = true;
        // this.onReset(); // Trigger automatically
      }
    });
  }

  WindowResize(e) {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 260);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.subscription.unsubscribe();
  }
  ngAfterViewInit() {
    this.sidenavService.setSidenav(this.sidenav);
  }
  selectedValue = "list";

  triggerResetFromHeader() {
    this.resetEventService.triggerReset();
  }

  shouldShowResetButton(): boolean {
    const excludedRoutes = ["/login", "/main/dashboard"]; // Add routes where button should NOT appear
    return this.isMobile && !excludedRoutes.includes(this.currentRoute);
  }

  shouldShowTitle(): boolean {
    const included = [
      "/main/driver-management/view",
      "/main/user-management/list",
      "/main/driver-management/driver-document-approval",
      "/main/service-management/view",
      "/main/vehicle-management/view-vehicle",
      "/main/dispatcher-management/view",
      "/main/vendor-manage",
      "/main/tax-management/view",
      "/main/booking-management/view-booking",
      "/main/payment-management/view-payment",
      "/main/manage-vehicle-tow",
      "/main/setting",
      "/main/create-booking/view",
      "/main/create-booking/add",
    ];
    return included.includes(this.currentRoute);
  }

  shouldShowLogo(): boolean {
    const excludedRoutes = [
      "/main/driver-management/view",
      "/main/user-management/list",
      "/main/driver-management/driver-document-approval",
      "/main/service-management/view",
      "/main/vehicle-management/view-vehicle",
      "/main/dispatcher-management/view",
      "/main/vendor-manage",
      "/main/tax-management/view",
      "/main/booking-management/view-booking",
      "/main/payment-management/view-payment",
      "/main/manage-vehicle-tow",
      "/main/setting",
      "/main/create-booking/view",
      "/main/create-booking/add",
    ];
    return !excludedRoutes.includes(this.currentRoute);
  }

  shouldShowDriverList(): boolean {
    const included = [
      "/main/driver-management/view",
      "/main/driver-management/driver-document-approval",
    ];
    return included.includes(this.currentRoute);
  }

  onDriverSelectionChange(value: string) {
    this.triggerEvents.updateSelection(value);
  }

  goBack() {
    this.triggerEvents.triggerBackNavigation(true);
  }
  isBookingScreen: boolean = false;
  back(data) {
    // console.log(this.isBookingScreen, "function clicked");

    if (this.isBookingScreen == true) {
      console.log("yes it is clicked");
      this.isBookingScreen = false;
      this.inCreateBooking = false;
      // this.serviceHeading = "Booking";
      this.dataService.setData5({ message: "back" });
    } else {
      this.dataService.setData({ message: data });
    }
  }
}
